module.exports = __webpack_public_path__ + "static/media/thumb-smartmirror.71966a23.png";